export default __webpack_public_path__ + "static/media/2.3c42d2d9.jpg";